import type { StartPartnershipCommandData } from '@festina/legalentity-general-types/legalentity'
import { FormikForm } from '@festina-life/ui/formikForms'

import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { PartnershipFormFields } from './PartnershipFormFields'

export const StartPartnershipCommandDataForm = (
  props: CommandDataFormProps<StartPartnershipCommandData>,
) => (
  <FormikForm
    initialValues={{
      _type: 'StartPartnershipCommandData',
    }}
    {...props}
  >
    <PartnershipFormFields fieldNamePrefix="" />
  </FormikForm>
)
